import { render, staticRenderFns } from "./BtnIcon.vue?vue&type=template&id=2bf88ebf&"
import script from "./BtnIcon.vue?vue&type=script&lang=js&"
export * from "./BtnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports